import React, { useContext } from 'react';
import * as R from 'ramda';
import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { GatekeeperNetworkServiceContext } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceContext';
import { Screens } from '../../services/analytics/screens';

function TokenInPartnerReviewScreen(): JSX.Element {
  const { gknServiceData } = useContext(GatekeeperNetworkServiceContext);
  const partnerName: string = R.propOr(false, 'partnerName', gknServiceData);

  return (
    <MessagePanel
      title="screens.tokenInPartnerReview.title"
      description="screens.tokenInPartnerReview.description"
      showLoading
      showSupportLink
      translationVariables={{ partnerName }}
    />
  );
}
export default withRouteAnalytics(TokenInPartnerReviewScreen, Screens.TOKEN_IN_PARTNER_REVIEW);
